import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { showErrorToast } from '../../../utils/toastUtils';
import { useClient } from '../../client-api';
import { type ClientPackageDto, type EnrichedClientDto, getClientPackagesForClient } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useClientPackagesForClient(customClient?: EnrichedClientDto): UseQueryResult<ClientPackageDto[], AxiosError> {
    const { t } = useTranslation();
    const { data: clientData } = useClient();
    const client = customClient ?? clientData;
    const queryKey = useMemo(() => queryKeys.clientPackagesForClient(client?.id), [client?.id]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => {
            try {
                return getClientPackagesForClient({ query: { clientId: client!.id }, signal }).then((result) => result.data);
            } catch (error) {
                showErrorToast({ error, userMessage: t('failureDocumentDownload') });

                return [];
            }
        },
        enabled: !!client,
    });
}
